import { Entity } from '@inter-ikea-core/core';
import {
  HelpLinesOuterMeasurementsLineCenterComponent,
  LabelPosition
} from '@inter-ikea-storageone/range';
import MeasurementsLabel from 'components/MeasurementsLabel/MeasurementsLabel';
import { useCore } from 'contexts/core';
import { useServiceSettings } from 'contexts/serviceSettings';
import { useTranslations } from 'hooks/useTranslations';
import { useEffect, useState } from 'react';
import { adjustMeasurementsSystem } from 'utils/adjustMeasurementsSystem';

const HelpLinesOuterMeasurementsWidget = () => {
  const [labels, setLabels] = useState<LabelPosition[]>([]);
  const coreApi = useCore();
  const { useMetric } = useTranslations();
  const { translations } = useServiceSettings();

  useEffect(() => {
    const entityManager = coreApi.getServices().entityManager;

    entityManager.subscribeAdd(
      HelpLinesOuterMeasurementsLineCenterComponent.id,
      (entity: Entity, newComponent: HelpLinesOuterMeasurementsLineCenterComponent) => {
        setLabels(newComponent.measurements);
      }
    );

    entityManager.subscribeRemove(HelpLinesOuterMeasurementsLineCenterComponent.id, () => {
      setLabels([]);
    });
  }, [coreApi, useMetric]);

  return (
    <>
      {labels.map(
        ({ dim, x, y, distance }, i) =>
          !!distance && (
            <MeasurementsLabel
              key={`${i}_${dim}_${distance}`}
              dim={dim}
              x={x}
              y={y}
              size={adjustMeasurementsSystem(distance, translations, useMetric, 1)}
              visible={true}
            />
          )
      )}
    </>
  );
};

export default HelpLinesOuterMeasurementsWidget;
